import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function StoreProductCard({ product }) {
  const navigate = useNavigate();

  const imageUrl = product?.image || "";
  const hasOffer =
    product?.has_offer &&
    product?.final_offer_price != null &&
    Number(product.final_offer_price) < Number(product.final_price || 0);

  const finalPrice = Number(
    hasOffer ? product?.final_offer_price : product?.final_price ?? 0
  );

  const originalPrice = Number(product?.final_price ?? 0);

  return (
    <Box
      sx={{
        width: "100%",
        minWidth: 0,
        maxWidth: { xs: 250, sm: "90%" },
        mx: "auto",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderRadius: { xs: "18px", md: "20px" },
        overflow: "hidden",
        bgcolor: "#ffffff",
        border: "1px solid rgba(0,0,0,0.08)",
        boxShadow: "0 8px 24px rgba(0,0,0,0.05)",
        transition: "transform .22s ease, box-shadow .22s ease, border-color .22s ease",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 16px 32px rgba(0,0,0,0.10)",
          borderColor: "rgba(0,0,0,0.12)",
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          height: { xs: 180, sm: 200, md: 210 },
          minHeight: { xs: 180, sm: 200, md: 210 },
          maxHeight: { xs: 180, sm: 200, md: 210 },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: { xs: 0.9, sm: 1, md: 1.2 },
          bgcolor: "#ffffff",
          borderBottom: "1px solid rgba(0,0,0,0.06)",
          overflow: "hidden",
        }}
      >
        {hasOffer && (
          <Box
            sx={{
              position: "absolute",
              top: { xs: 9, md: 11 },
              left: { xs: 9, md: 11 },
              px: { xs: 0.9, md: 1 },
              py: 0.45,
              borderRadius: 999,
              bgcolor: "#e50914",
              color: "#ffffff",
              fontSize: { xs: 10, md: 10.8 },
              fontWeight: 800,
              lineHeight: 1,
              zIndex: 2,
            }}
          >
            Oferta
          </Box>
        )}

        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            minWidth: 0,
          }}
        >
          <Box
            component="img"
            src={imageUrl || "https://via.placeholder.com/700x700?text=NovaXfit"}
            alt={product?.name || "Producto"}
            loading="lazy"
            sx={{
              maxWidth: "100%",
              maxHeight: "100%",
              width: "auto",
              height: "auto",
              objectFit: "contain",
              display: "block",
            }}
          />
        </Box>
      </Box>

      <Box
        sx={{
          p: { xs: 1.1, sm: 1.3, md: 1.45 },
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          minWidth: 0,
          width: "100%",
          maxWidth: "100%",
          overflow: "hidden",
        }}
      >
        {product?.brand && (
          <Typography
            sx={{
              width: "100%",
              minWidth: 0,
              maxWidth: "100%",
              fontSize: { xs: 11.6, sm: 12.2, md: 12.8 },
              color: "#8a8a8a",
              fontWeight: 500,
              mb: 0.25,
              lineHeight: 1.2,
              textAlign: "left",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            title={product.brand}
          >
            {product.brand}
          </Typography>
        )}

        <Typography
          sx={{
            width: "100%",
            minWidth: 0,
            maxWidth: "100%",
            fontSize: { xs: 17, sm: 18, md: 20 },
            fontWeight: 800,
            color: hasOffer ? "#e50914" : "#111111",
            lineHeight: 1,
            mb: hasOffer ? 0.35 : 0.55,
            textAlign: "left",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          ${finalPrice.toFixed(2)}
        </Typography>

        {hasOffer && (
          <Typography
            sx={{
              width: "100%",
              minWidth: 0,
              maxWidth: "100%",
              fontSize: { xs: 11.8, sm: 12.4, md: 13.2 },
              fontWeight: 700,
              color: "#9a9a9a",
              textDecoration: "line-through",
              mb: 0.45,
              lineHeight: 1,
              textAlign: "left",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            ${originalPrice.toFixed(2)}
          </Typography>
        )}

        <Typography
          sx={{
            width: "100%",
            minWidth: 0,
            maxWidth: "100%",
            fontSize: { xs: 11.5, sm: 12, md: 12.4 },
            fontWeight: 500,
            color: "#666666",
            lineHeight: 1.2,
            mb: 0.65,
            textAlign: "left",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          Precio incluye IVA
        </Typography>

        <Typography
          sx={{
            width: "100%",
            minWidth: 0,
            maxWidth: "100%",
            fontSize: { xs: 14.2, sm: 15.2, md: 17 },
            fontWeight: 700,
            color: "#111111",
            lineHeight: 1.2,
            mb: 0.45,
            minHeight: { xs: "2.4em", md: "2.4em" },
            maxHeight: { xs: "2.4em", md: "2.4em" },
            textAlign: "left",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            wordBreak: "break-word",
          }}
          title={product?.name || ""}
        >
          {product?.name}
        </Typography>

        {product?.category && (
          <Typography
            sx={{
              width: "100%",
              minWidth: 0,
              maxWidth: "100%",
              fontSize: { xs: 11.8, sm: 12.3, md: 13 },
              color: "#7b7b7b",
              fontWeight: 500,
              mb: { xs: 0.95, md: 1.1 },
              lineHeight: 1.25,
              textAlign: "left",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            title={product.category}
          >
            {product.category}
          </Typography>
        )}

        <Button
          fullWidth
          onClick={() => navigate(`/tienda/producto/${product.slug}`)}
          sx={{
            mt: "auto",
            py: { xs: 0.8, md: 0.95 },
            borderRadius: "11px",
            textTransform: "none",
            fontSize: { xs: 13, sm: 13.5, md: 14 },
            fontWeight: 700,
            color: "#ffffff",
            bgcolor: "#111111",
            border: "1px solid #111111",
            "&:hover": {
              bgcolor: "#000000",
              borderColor: "#000000",
            },
          }}
        >
          Ver producto
        </Button>
      </Box>
    </Box>
  );
}